import { useSyncExternalStore } from "react"

interface HeaderState {
  navigationContext: { pathname: string; activePath: string } | null
  title: string | null
  onRefresh: (() => void) | null
}

let state: HeaderState = {
  navigationContext: null,
  title: null,
  onRefresh: null
}

const listeners = new Set<() => void>()

export const headerStore = {
  setNavigationContext(navigationContext: HeaderState["navigationContext"]) {
    state = { ...state, navigationContext }
    listeners.forEach((listener) => listener())
  },
  setTitle(title: string | null) {
    state = { ...state, title }
    listeners.forEach((listener) => listener())
  },
  setOnRefresh(onRefresh: (() => void) | null) {
    state = { ...state, onRefresh }
    listeners.forEach((listener) => listener())
  },
  subscribe(listener: () => void) {
    listeners.add(listener)
    return () => listeners.delete(listener)
  },
  getSnapshot() {
    return state
  }
}

export function useHeaderState() {
  return useSyncExternalStore(headerStore.subscribe, headerStore.getSnapshot)
}
